import iconQuit from '@assets/images/static/icon-quit-bg.png';
import iconValid from '@assets/images/static/icon-valid-bg.png';
import iconWarning from '@assets/images/static/icon-warning.svg';
import React from 'react';
import { styled } from 'styled-components';
import { SDivAutor, SIcon } from '~/pages/components/styles/styles';
import { classic } from '~/themes';

type IProps = {
  children: React.ReactNode;
  onClick?: () => void;
  selected: boolean;
  submitted: boolean;
  status?: 'good' | 'wrong' | 'warning' | 'neutral';
  autor?: string;
};

type TProps = IProps;

export function QcuQcmItem({
  selected,
  status,
  submitted,
  onClick,
  autor,
  children,
}: TProps) {
  return (
    <Container
      $status={status}
      $submitted={submitted}
      onClick={onClick}
      selected={selected}
    >
      {children}
      {autor && <SDivAutor>{autor}</SDivAutor>}
      {submitted && status === 'good' && <SIcon src={iconValid} alt="" />}
      {submitted && status === 'wrong' && <SIcon src={iconQuit} alt="" />}
      {submitted && status === 'warning' && <SIcon src={iconWarning} alt="" />}
    </Container>
  );
}

const Container = styled.button<{
  selected?: boolean;
  $submitted: boolean;
  $status?: 'good' | 'wrong' | 'warning' | 'neutral';
}>`
  align-items: center;
  cursor: pointer;

  border-radius: 20px;
  box-shadow:
    inset 0 3.6px 3.6px 0 rgba(255, 255, 255, 0.35),
    inset 0 -3.6px 3.6px 0 rgba(0, 0, 0, 0.4),
    0 4px 4px 0 rgba(0, 0, 0, 0.1);

  background-image: ${({ $submitted, selected, $status }) => {
    if (!$submitted) {
      return selected
        ? 'linear-gradient(to bottom, #63b7c9, #009fc3)'
        : 'linear-gradient(to bottom, #bbe6ef, #fff),linear-gradient(to bottom, #ccecf3, #ccecf3)';
    } else {
      if ($status === 'good')
        return 'linear-gradient(to bottom, #5ee49d, #14b15c)';
      if ($status === 'wrong')
        return 'linear-gradient(to bottom, #e06363, #dd4848)';
      if ($status === 'warning')
        return 'linear-gradient(to bottom, #da8960, #dd6848)';
      return 'linear-gradient(to bottom, #bbe6ef, #fff), linear-gradient(to bottom, #ccecf3, #ccecf3)';
    }
  }};

  color: ${classic.token?.colorTextSecondary};

  color: ${({ $submitted, selected, $status }) => {
    if (!$submitted) {
      return selected
        ? `${classic.token?.colorWhite}`
        : `${classic.token?.colorTextSecondary}`;
    } else {
      if ($status === 'good' || $status === 'wrong' || $status === 'warning') {
        return `${classic.token?.colorWhite}`;
      } else {
        return `${classic.token?.colorTextSecondary}`;
      }
    }
  }};

  font-weight: 700;
  font-size: 1.1rem;
  display: flex;
  height: 100px;
  justify-content: center;
  margin: 0 10px;
  position: relative;
  pointer-events: ${({ $submitted }) => ($submitted ? 'none' : 'auto')};
  text-align: center;
  width: 42%;
  user-select: none;

  &:focus {
    outline: 0;
    font-size: 1.2rem;
  }

  @media screen and (max-width: 415px) {
    height: 80px;
    margin: 0 12px;
    font-size: 1rem;
    &:focus {
      outline: 0;
      font-size: 1.05rem;
    }
  }

  @media screen and (max-height: 600px) {
    height: 80px;
    margin: 0 12px;
    font-size: 1rem;
    font-size: 1.05rem;
  }
`;
